import { render, staticRenderFns } from "./DashboardStats.vue?vue&type=template&id=acf0d4b6&scoped=true&"
import script from "./DashboardStats.vue?vue&type=script&lang=js&"
export * from "./DashboardStats.vue?vue&type=script&lang=js&"
import style0 from "./DashboardStats.vue?vue&type=style&index=0&id=acf0d4b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf0d4b6",
  null
  
)

export default component.exports